import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Typography } from "@mui/material";
import { useState } from "react";
import { renderIcon } from "../../utils/icon/Landing-Page/Icon";
import { Link } from "react-router-dom";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { CTAImgData } from "../../utils/data/Landing-Page/data";
import { Link as RouterLink } from 'react-router-dom';

export const CTA = () => {
    return (
        <Box sx={{ background: '#201E1D', borderRadius: '20px', minHeight: '670px', display: 'flex', mb: 7, justifyContent: 'space-between' }}>
            <Box sx={{ width: '40%', pl: 5, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <Typography sx={{ fontSize: '20px', color: '#0057D5', fontWeight: '700', py: 4 }}>EXPLORE NOW</Typography>
                <Typography sx={{ fontSize: '40px', color: '#fff', fontWeight: '700', py: 2 }}>Ready to Transform Your<br /> Project Management?</Typography>
                <Typography sx={{ fontSize: '20px', color: '#FFFFFFA3', fontWeight: '500', py: 2 }}>Start using our product and see immediate improvements in<br /> your project outcomes.</Typography>
                <Box sx={{ my: 2 }}>
                    <RouterLink to="/Reg" style={{ textDecoration: 'none' }}>
                        <Button sx={{ color: '#fff', background: '#FF2800', height: '50px', mx: '10px', textTransform: 'capitalize', '&:hover': { background: '#FF280099' }, px: 3 }}>Get Started</Button>
                    </RouterLink>
                        <Button disableRipple sx={{ color: '#474747', height: '50px', border: '0.6px solid #474747', fontWeight: '500', fontSize: '18px', mx: '10px', textTransform: 'capitalize', px: 3 }}><a href="mailto:support@planshareai" style={{ textDecoration: 'none', color: 'inherit' }}>Contact Us</a></Button>
                </Box>
            </Box>
            <Box sx={{ width: '50%', display: 'flex', justifyContent: 'end', alignItems: 'end' }}>
                <ImgHover2 data={CTAImgData} />
            </Box>
        </Box>
    );
}

export const FAQ = ({ e, i }) => {
    // const [expanded, setExpanded] = useState(false);

    // const handleChange = (panel) => (event, isExpanded) => {
    //     setExpanded(isExpanded ? event : false);
    // };
    return (
        <Accordion sx={{ my: 1, borderRadius: '8px', boxShadow: 0, background: 'transparent', width: '100%', my: 2, px: 0, "&:hover": { boxShadow: 0 } }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography sx={{}}>{e.question}</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ width: '100%', pr: 4 }}>
                <Typography>{e.answer}</Typography>
            </AccordionDetails>
        </Accordion>
    );
}

export const PricePlan = ({ data, setPrice, i, black }) => {
    return (
        <Box
            onClick={() => setPrice(i)}
            sx={{
                border: '1px solid #E4E4E4',
                cursor: 'pointer',
                color: black ? '#FFFFFF' : '#000000',
                background: black ? '#000000' : '',
                p: 3,
                borderRadius: '8px',
                minWidth: '280px',
                mx: 2,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
            }}
        >
            <Box>
                <Box sx={{ display: 'flex' }}>
                    <Typography sx={{ fontWeight: '500', fontSize: '24px', mr: 2 }}>{data.title}</Typography>
                    {data.popular && <Typography sx={{ fontWeight: '500', fontSize: '12px', color: '#fff', height: '26px', display: 'flex', justifyContent: 'center', alignItems: 'center', px: 4, background: '#FF2800', borderRadius: '15px' }}>{data.popular}</Typography>}
                </Box>
                {data.text && <Typography sx={{ fontWeight: '500', fontSize: '14px', color: '#727272', mb: 3 }}>{data.text}</Typography>}
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {data.price && <Typography sx={{ fontWeight: '500', fontSize: '32px', pr: '5px' }}>{data.price}</Typography>}
                    {data.discount && <Typography sx={{ fontWeight: '500', fontSize: '12px', background: black ? '#4B4B4B' : '#F2F2F2', padding: '2px 6px', borderRadius: '4px' }}>{data.discount}</Typography>}
                </Box>
                {data.subText && <Typography sx={{ fontWeight: '500', textAlign: 'left', fontSize: '12px', mb: 2, color: black ? '#AFAFAF' : '' }}>{data.subText}</Typography>}
                <Typography sx={{ fontWeight: '500', fontSize: '14px', textAlign: 'left', color: black ? '#D8D8D8' : '#000' }}>{data.mainSubText}</Typography>
                <Box>
                    {data.subTextData.map((item, idx) => (
                        <Box key={idx} sx={{ display: 'flex', alignItems: 'center', py: '10px' }}>
                            {renderIcon(black)}
                            <Typography sx={{ fontWeight: '500', fontSize: '14px', pl: '7px' }}>{item.title}</Typography>
                        </Box>
                    ))}
                </Box>
            </Box>
            <Link to={'#'}> 
                <RouterLink to="/Reg" style={{ textDecoration: 'none' }}>
                <Button sx={{ border: !black && '1px solid #CAD0D9', textTransform: 'capitalize', background: black ? '#FF2800' : 'transparent', color: black ? '#fff' : '#040815', '&:hover': { background: black && '#FF280099' }, width: '100%', mt: 4 }}>
                    {data.btn}
                </Button>
                </RouterLink>
            </Link>
        </Box>
    );
}

export const SwitchButton = () => {
    const [btn, setBtn] = useState(false);
    const btnTrue = {
        textTransform: 'capitalize',
        color: '#2E3238',
        background: '#fff',
        fontSize: '14px',
        fontWeight: '600',
        display: 'flex',
        borderRadius: '15px',
        width: '158px',
        '&:hover': {
            background: '#fff'
        }
    }
    const btnFalse = {
        textTransform: 'capitalize',
        color: '#2E3238',
        fontSize: '14px',
        fontWeight: '500',
        display: 'flex',
        width: '158px',
        // '&:hover': {
        //     background: '#2E3238'
        // }
    }
    return (
        <Box sx={{ height: '40px', width: 'max-content', p: '2px', borderRadius: '12px', background: '#F3F4F6', display: 'flex', justifyContent: 'space-between' }}>
            <Button disableRipple sx={btn ? btnTrue : btnFalse} onClick={() => setBtn(true)}>Monthly</Button>
            <Button disableRipple sx={!btn ? btnTrue : btnFalse} onClick={() => setBtn(false)}>
                <Typography sx={{ mr: 2 }}>Annual</Typography>
                <Typography sx={{ color: '#0057D5', fontSize: '12px', fontWeight: '400', background: '#F3F4F6', p: 1, height: '19px', textWrap: 'nowrap', borderRadius: '15px' }}>Save 35%</Typography>
            </Button>
        </Box>
    );
}

export const ImgHover2 = ({ data }) => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'end', minHeight: data.opH, width: data.opW, background: '#fff', borderRadius: '12px' }}>
            <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'end', minHeight: data.ipH, width: data.ipW, background: '#F3F5F7', borderRadius: '12px' }}>
                <img src={data.img} alt="" style={{ height: data.imgh, width: data.imgw }} />
            </Box>
        </Box>
    );
}


export const BenefitsCard = ({ data }) => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'flex-start', my: 4 }}>
            <data.icon />
            <Box sx={{ ml: 2 }}>
                <Typography sx={{ fontSize: '24px', color: '#040815', fontWeight: '600' }}>{data.title}</Typography>
                <Typography sx={{ fontSize: '16px', color: '#474747', fontWeight: '500' }}>{data.text}</Typography>
            </Box>
        </Box>
    );
}


export const FeaturesCard = ({ data }) => {
    return (
        <Box sx={{ width: data.wd }}>
            <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'end', minHeight: '400px', background: '#F3F5F7', borderRadius: '12px' }}>
                <img src={data.img} alt="" style={{ height: '300px', width: '300px' }} />
            </Box>
            <Box>
                <Typography sx={{ fontSize: '24px', color: '#040815', fontWeight: '600' }}>{data.title}</Typography>
                <Typography sx={{ fontSize: '16px', color: '#474747', fontWeight: '500' }}>{data.text}</Typography>
            </Box>
        </Box>
    );
}

